import { render, staticRenderFns } from "./PlantConfigurationAlertsPage.vue?vue&type=template&id=f2719f92&"
import script from "./PlantConfigurationAlertsPage.vue?vue&type=script&lang=js&"
export * from "./PlantConfigurationAlertsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports